
import {Observable, of, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {Session} from './Session';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {TaxplanIQServices} from "./TaxplanIQServices";
import {PATH, SOURCE_TYPE} from "../constants/Tpiq.constants";

declare let _: any;

export function getTypeBasedLabelsUrl(org, labelType) {
    return `/TaxPlanningServices/orgs/${org}/labels/labelTypes/${labelType}`;
}

@Injectable({
  providedIn: 'root'
})
export class ManageLabelsService extends  TaxplanIQServices {

    options = {};
    labelTypes = {};
    constructor(http: HttpClient) {
        super(http);
    }

    getPaginatedLabels(obj): Observable<any> {
        const url = this.interpolateUrl(PATH.LABELS_TYPE_SERVICE, {}, {org: Session.getOrg()});
        return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getTypeLabels(obj): Observable<any> {
        const url = getTypeBasedLabelsUrl(Session.getOrg(), obj.labelType);
        return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getLabelType(type, org, clearCache?): Observable<any> {
        if (clearCache) {
            this.labelTypes = {};
        }
        if (this.labelTypes[type]  && !_.isEmpty(this.labelTypes[type])) {
            return of(this.labelTypes[type]);
        }
        const url = this.interpolateUrl(PATH.GET_ALL_LABELS, null, {org, type});
        return this.query(url , SOURCE_TYPE.JAVA).pipe(map((res) => {
            this.labelTypes[type] = res;
            return this.labelTypes[type];
        }), catchError(this.handleError));
    }

    addLabelType(obj): Observable<any> {
        const url = this.interpolateUrl(PATH.LABELS_TYPE_SERVICE, {}, {org: Session.getOrg()});
        return this.update(url + '/' + obj.labelType, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    addPostLabelType(org, user, selectedlabels): Observable<any> {
        const url = this.interpolateUrl(PATH.POST_LABELS_SERVICE, {}, {org, userId: user});
        return this.create(url, selectedlabels, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getPostLabels(org, user): Observable<any> {
        const url = this.interpolateUrl(PATH.POST_LABELS_SERVICE, {}, {org, userId: user});
        return this.query(url , SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

   private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }

}

